import React, { CSSProperties, FC, useState } from 'react';
import { DatePicker, Form, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { getDateFormat } from 'src/common/utils';
import moment, { Moment } from 'moment';
import { RoleAssignmentAttributes } from 'src/stores/role-assignments-store';

const { Text } = Typography;

const disabledDate = (current: any) => {
  return current && current < moment.now();
};

type RoleAssignmentAttributesComponentProps = {
  onChange: (item: RoleAssignmentAttributes) => void;
  initialValue?: Date;
  customFormFieldName?: string | (string | number)[];
  usingForm?: boolean;
  showLabel?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
};

const RoleAssignmentAttributesComponent: FC<RoleAssignmentAttributesComponentProps> = ({
  onChange,
  initialValue,
  customFormFieldName,
  usingForm = true,
  showLabel = true,
  disabled = false,
  style,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue ? moment(initialValue) : null);

  return (
    <>
      {usingForm && (
        <Form.Item
          name={customFormFieldName ?? 'expirationDate'}
          rules={disabled ? undefined : [{ required: true, message: t('PleaseEnterExpirationDate') }]}
          style={style ?? { width: 'calc(47%)' }}
          label={showLabel ? t('ExpirationDate') : undefined}
          initialValue={initialValue ? moment(initialValue) : undefined}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder={t('ExpirationDate')}
            disabled={disabled}
            format={getDateFormat()}
            disabledDate={disabledDate}
            onChange={(v: Moment | null) => onChange({ expirationDate: v?.toDate() })}
          />
        </Form.Item>
      )}

      {!usingForm && (
        <>
          {showLabel && (
            <>
              <Text className="required-label">{t('ExpirationDate')}: </Text>
              <br />
            </>
          )}
          <DatePicker
            disabled={disabled}
            value={value}
            format={getDateFormat()}
            disabledDate={disabledDate}
            onChange={(v: Moment | null) => {
              onChange({ expirationDate: v?.toDate() });
              setValue(v);
            }}
          />
        </>
      )}
    </>
  );
};

export default RoleAssignmentAttributesComponent;
